import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=5bbcd00b&scoped=true&"
import script from "./RawData.vue?vue&type=script&lang=js&"
export * from "./RawData.vue?vue&type=script&lang=js&"
import style0 from "./RawData.vue?vue&type=style&index=0&id=5bbcd00b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbcd00b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
